<template>
  <div class="video_box" v-show="show">
    <div class="video_content">
      <div id="dplayer" ref="player" class="dplayer video-box"></div>
    </div>
    <div class="close" @click="close">
      <a-icon type="close-circle" />
    </div>
  </div>
</template>
<script>
//引入m3u8播放器
import Hls from "hls.js";
import DPlayer from "dplayer";

export default {
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    coverUrl: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      defalut: false
    }
  },
  model: {
    prop: "show",
    event: "change",
  },
  data() {
    return {
      dp: null,
    }
  },
  created() {

    this.$watch('show', (val) => {
      if (val == true) {

        this.dp = new DPlayer({
          element: this.$refs.player,
          loop: false,
          autoplay: true,
          video: {
            pic: this.coverUrl,
            url: this.fileUrl,
            type: "customHls",
            customType: {
              customHls: function (video, player) {
                const hls = new Hls();
                hls.loadSource(video.src);
                hls.attachMedia(video);
              },
            },
          },
        });
      }
    });
  },
  methods: {
    close() {
      this.$emit('change', false)
    }
  },

}
</script>

<style lang="less" scoped>
.video_box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  background: rgba(0, 0, 0, 0.6);
  overflow-y: scroll;

  .close {
    position: fixed;
    z-index: 20;
    right: 50px;
    top: 10%;
    color: white;
    font-size: 30px;
    cursor: pointer;

    &:hover {
      opacity: .6;
    }
  }

  .video_content {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 700px;
    height: 700px;
  }
}

::v-deep .dplayer-video-wrap .dplayer-video {
  height: 700px;
}

::v-deep .dplayer-menu,
.dplayer-mask {
  display: none !important;
}
</style>